import React, { useState } from 'react';
import '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import { ConditionalWrapper } from '../../primitives/ConditionalWrapper/ConditionalWrapper.es.js';
import { VisuallyHidden } from '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { Tooltip } from '../Tooltip/Tooltip.es.js';
import { Styled } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Switch = forwardRef((_a, ref) => {
  var _b = _a, {
    id,
    offLabel,
    onLabel,
    tooltipOnText,
    tooltipOffText,
    size = "md",
    isOn,
    isDisabled,
    isInvalid,
    onChange,
    onFocus,
    onBlur,
    children
  } = _b, props = __objRest(_b, [
    "id",
    "offLabel",
    "onLabel",
    "tooltipOnText",
    "tooltipOffText",
    "size",
    "isOn",
    "isDisabled",
    "isInvalid",
    "onChange",
    "onFocus",
    "onBlur",
    "children"
  ]);
  const [isChecked, setIsChecked] = useState();
  const handleOnChange = (e) => {
    setIsChecked(e.target.checked);
    onChange == null ? void 0 : onChange(e);
  };
  return /* @__PURE__ */ React.createElement(Styled.ComponentWrapper, __spreadValues({}, props), /* @__PURE__ */ React.createElement(ConditionalWrapper, {
    condition: tooltipOnText && tooltipOffText,
    wrapper: (children2) => /* @__PURE__ */ React.createElement(Tooltip, {
      content: isChecked ? tooltipOnText : tooltipOffText,
      position: "top"
    }, children2)
  }, /* @__PURE__ */ React.createElement(VisuallyHidden, {
    as: "input",
    type: "checkbox",
    id,
    disabled: isDisabled,
    onChange: handleOnChange,
    onFocus,
    onBlur,
    checked: isOn,
    "aria-invalid": isInvalid,
    "aria-checked": isOn,
    ref
  }), offLabel && /* @__PURE__ */ React.createElement(Styled.OffLabel, {
    size
  }, offLabel), /* @__PURE__ */ React.createElement(Styled.OuterSwitch, {
    size,
    isDisabled
  }, /* @__PURE__ */ React.createElement(Styled.InnerSwitch, {
    size,
    isDisabled
  }, /* @__PURE__ */ React.createElement(Styled.Handle, {
    size,
    isDisabled
  }))), onLabel && /* @__PURE__ */ React.createElement(Styled.OnLabel, {
    size
  }, onLabel)));
});
Switch.displayName = "Switch";

export { Switch };
//# sourceMappingURL=Switch.es.js.map
